<div class="controls">
    <div class="left">
        <lightswitch [labelLeft]="'ui.notification_list_controls.show_unread' | translate" [labelRight]="'ui.notification_list_controls.show_all' | translate" [status]="showAll" (changeStatus)="handleShowAllChange()"></lightswitch>
    </div>
    <div class="right">
        <a class="read-all" (click)="markAllAsRead()">{{'ui.notification_list_controls.mark_read' | translate}}</a>
    </div>
</div>
